import React from 'react';
import { CrmDateInput } from '../ui';

function CrmDateFilterInput({ value, onChange, dateFormat = 'DD/MM/YYYY', ariaLabel }) {
  return (
    <CrmDateInput
      className="crm-date-filter-input"
      value={value || ''}
      dateFormat={dateFormat}
      showFormatHint={false}
      aria-label={ariaLabel}
      onChange={onChange}
    />
  );
}

export default CrmDateFilterInput;
